/**
 * @method debounce 函数防抖
 */
function debounce(func, wait = 500, immediate = true) {
  let timeout = null
  return function () {
    const context = this
    const args = arguments
    const callNow = immediate && !timeout
    if (callNow) func.apply(context, args)
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      timeout = null
      if (!immediate) func.apply(context, args)
    }, wait)
  }
}

/**
 * @method throttle 函数节流
 */
function throttle(func, wait = 500) {
  let timeout = null
  return function () {
    const context = this
    const args = arguments
    if (!timeout) {
      func.apply(context, args)
      timeout = setTimeout(() => {
        clearTimeout(timeout)
        timeout = null
      }, wait)
    }
  }
}

const formatNumber = (n) => {
  n = n.toString()
  return n[1] ? n : `0${n}`
}

const formatTime = (date) => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()

  return `${[year, month, day].map(formatNumber).join('-')}`
}

function getUrlParams(path) {
  if (!path) return
  path = decodeURIComponent(path)
  var data = {}
  var reg = new RegExp('([^?=&]+)(=([^&]*))?', 'g')
  path &&
    path.replace(reg, function ($0, $1, $2, $3) {
      data[$1] = $3
    })
  return data
}

function getUrlParam(path, name) {
  path = decodeURIComponent(path)
  const reg = new RegExp('(^|&|\\?)' + name + '=([^&\\?]*)(&|$|\\?)')
  const res = path.match(reg)
  let value = ''
  if (res) {
    value = res[2]
  }
  return value
}

function arrayToMap(array = [], key, value) {
  const obj = {}
  for (let item of array) {
    obj[item[key]] = item[value]
  }
  return obj
}

function groupBy(arr, key) {
  return arr.reduce((acc, item) => {
    acc[item[key]] = [...(acc[item[key]] || []), item]
    return acc
  }, {})
}

function delay(time) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve()
    }, time)
  })
}

function maskPhone(phone) {
  if (!phone) return ''
  let str = String(phone);
  return str.slice(0, 3) + '****' + str.slice(-4)
}

export { debounce, throttle, formatTime, getUrlParam, getUrlParams, arrayToMap, groupBy, delay, maskPhone }
